module.exports = __webpack_public_path__ + "static/media/17UN-Women2.aa039b89.jpg";